import MENU from './translations/menu';
import GENERAL from './translations/general';
import PAGES from './translations/pages';
import PLACEHOLDER from './translations/placeholder';
import PRODUCTS from './translations/products';
import SYSTEMS from './translations/systems';
import ERRORS from './translations/errors';
import MESSAGES from './translations/messages';
import REGISTER from './translations/register';
import CHECKOUT from './translations/checkout';
import STATUS from './translations/status';
import CONFIG from './translations/config';
import LANGUAGES from './translations/languages';

export default {
  menu: MENU,
  general: GENERAL,
  pages: PAGES,
  placeholder: PLACEHOLDER,
  products: PRODUCTS,
  systems: SYSTEMS,
  errors: ERRORS,
  messages: MESSAGES,
  register: REGISTER,
  checkout: CHECKOUT,
  status: STATUS,
  config: CONFIG,
  languages: LANGUAGES,
};
